import {
	Category,
	Event,
	EventMinData,
	PriceLevel,
	Seatingplan,
	Sponsor,
	SponsorCodeModel,
	SponsorCodeUsageModel,
	TicketQuota,
	Venue
} from "../../models"
import { SponsorActions } from './sponsor.actions';
import { SponsorsFreeSeating } from "../../models/sponsors-freeSeating.model";

export interface SponsorState {
	sponsorList: Sponsor[],
	sponsor: Sponsor,
	selectedSponsorCode: SponsorCodeModel,
	sponsorCodes: SponsorCodeModel[],
	sponsorCodeUsages: SponsorCodeUsageModel[],
	selectedSponsorCodeUsage: SponsorCodeUsageModel,
	codeUsageSeats: string[],
	freeSeatings: SponsorsFreeSeating[],
	reservations: { seats: string[], freeSeatings: SponsorsFreeSeating[] }
	codeUsageEventList: EventMinData[]
	spEvent: Event,
	spVenue: Venue,
	seatingplan: Seatingplan,
	ticketQuotas: TicketQuota[],
	spCategory: Category,
	spPriceLevel: PriceLevel
}

const initialState: SponsorState = {
	sponsorList: [],
	sponsor: null,
	selectedSponsorCode: null,
	sponsorCodes: null,
	sponsorCodeUsages: [],
	selectedSponsorCodeUsage: null,
	codeUsageSeats: [],
	freeSeatings: [],
	reservations: null,
	codeUsageEventList: null,
	spEvent: null,
	spVenue: null,
	seatingplan: null,
	ticketQuotas: [],
	spCategory: null,
	spPriceLevel: null
}

export const sponsorsReducer = (state = initialState, action): SponsorState => {
	switch (action.type) {
		case SponsorActions.LOAD_SPONSOR_LIST_SUCCESS: {
			return Object.assign({}, state, {
				sponsorList: action.payload,
				codeUsageEventList: null
			})
		}

		case SponsorActions.LOAD_SPONSOR_SUCCSESS: {
			return Object.assign({}, state, {
				sponsor: action.payload,
			})
		}

		case SponsorActions.LOAD_SPONSOR_CODES_SUCCESS: {
			return Object.assign({}, state, {
				sponsorCodes: action.payload,
			})
		}

		case SponsorActions.SPONSOR_CODE_LOADED: {
			return Object.assign({}, state, {
				selectedSponsorCode: action.payload
			})
		}

		case SponsorActions.LOAD_SPONSOR_CODE_USAGES_SUCCESS: {
			return Object.assign({}, state, {
				sponsorCodeUsages: action.payload
			})
		}

		case SponsorActions.SPONSOR_CODE_USAGE_LOADED: {
			return Object.assign({}, state, {
				selectedSponsorCodeUsage: action.payload
			})
		}

		case SponsorActions.CLEAR_SELECTED_CODE_USAGE: {
			return Object.assign({}, state, {
				selectedSponsorCodeUsage: initialState.selectedSponsorCodeUsage
			})
		}

		case SponsorActions.LOAD_CODE_USAGE_EVENT_LIST_SUCCESS: {
			return Object.assign({}, state, {
				codeUsageEventList: action.payload
			})
		}

		case SponsorActions.SEATS_LOADED: {
			return Object.assign({}, state, {
				codeUsageSeats: action.payload
			})
		}

		case SponsorActions.FS_LOADED: {
			return Object.assign({}, state, {
				freeSeatings: action.payload
			})
		}

		case SponsorActions.SET_RESERVATIONS_BY_EVENT_UUID: {
			return Object.assign({}, state, {
				reservations: action.payload
			})
		}

		// Seatingplan

		case SponsorActions.CLEAR_SP_DATA: {
			return Object.assign({}, state, {
				spEvent: initialState.spEvent,
				spVenue: initialState.spVenue,
				seatingplan: initialState.seatingplan,
				ticketQuotas: initialState.ticketQuotas
			})
		}

		case SponsorActions.SP_EVENT_LOADED: {
			return Object.assign({}, state, {
				spEvent: action.payload
			})
		}

		case SponsorActions.SP_VENUE_LOADED: {
			return Object.assign({}, state, {
				spVenue: action.payload
			})
		}

		case SponsorActions.SEATINGPLAN_LOADED: {
			return Object.assign({}, state, {
				seatingplan: action.payload
			})
		}

		case SponsorActions.TICKET_QUOTAS_LOADED: {
			return Object.assign({}, state, {
				ticketQuotas: action.payload
			})
		}

		case SponsorActions.SP_CATEGORY_LOADED: {
			return Object.assign({}, state, {
				spCategory: action.payload
			})
		}

		case SponsorActions.SP_PRICELEVEL_LOADED: {
			return Object.assign({}, state, {
				spPriceLevel: action.payload
			})
		}

		default: {
			return state
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/sponsors/sponsor.reducer.ts